/*
 * W Secret — Wishlist (localStorage)
 * ----------------------------------------------------------
 * Persistencia de favoritos por navegador/dispositivo.
 * - Toggle al dar clic en cualquier boton .product-card__wishlist
 * - Actualiza contador del icono del navbar en tiempo real
 * - Sincroniza entre tabs abiertas del mismo navegador
 * - Expone window.WSWishlist para que otras secciones consulten
 *
 * API publica:
 *   WSWishlist.has(handle)      -> boolean
 *   WSWishlist.add(item)        -> array actualizado
 *   WSWishlist.remove(handle)   -> array actualizado
 *   WSWishlist.toggle(item)     -> { added: boolean, items: array }
 *   WSWishlist.getAll()         -> array de items guardados
 *   WSWishlist.clear()          -> []
 *
 * Evento custom: 'wishlist:change' (en document) con detail { items, count }
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'ws_wishlist_v1';

  function safeParse(raw) {
    try {
      var parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function readStorage() {
    try {
      return safeParse(localStorage.getItem(STORAGE_KEY));
    } catch (e) {
      return [];
    }
  }

  function writeStorage(items) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (e) {
      /* Storage lleno o bloqueado — ignoramos en silencio */
    }
  }

  function emitChange(items) {
    var event;
    try {
      event = new CustomEvent('wishlist:change', {
        detail: { items: items, count: items.length }
      });
    } catch (e) {
      event = document.createEvent('CustomEvent');
      event.initCustomEvent('wishlist:change', false, false, {
        items: items, count: items.length
      });
    }
    document.dispatchEvent(event);
  }

  var WSWishlist = {
    getAll: function () {
      return readStorage();
    },
    has: function (handle) {
      if (!handle) return false;
      var items = readStorage();
      for (var i = 0; i < items.length; i++) {
        if (items[i].handle === handle) return true;
      }
      return false;
    },
    add: function (item) {
      if (!item || !item.handle) return readStorage();
      var items = readStorage();
      for (var i = 0; i < items.length; i++) {
        if (items[i].handle === item.handle) {
          return items;
        }
      }
      item.addedAt = Date.now();
      items.push(item);
      writeStorage(items);
      emitChange(items);
      return items;
    },
    remove: function (handle) {
      if (!handle) return readStorage();
      var items = readStorage();
      var next = [];
      for (var i = 0; i < items.length; i++) {
        if (items[i].handle !== handle) next.push(items[i]);
      }
      if (next.length !== items.length) {
        writeStorage(next);
        emitChange(next);
      }
      return next;
    },
    toggle: function (item) {
      if (!item || !item.handle) return { added: false, items: readStorage() };
      if (WSWishlist.has(item.handle)) {
        return { added: false, items: WSWishlist.remove(item.handle) };
      }
      return { added: true, items: WSWishlist.add(item) };
    },
    clear: function () {
      writeStorage([]);
      emitChange([]);
      return [];
    }
  };

  window.WSWishlist = WSWishlist;

  /* ─────────────────────────────────────────────────────────
     UI: marcar botones .product-card__wishlist y hacerlos
     funcionales (delegacion de eventos para que funcione con
     contenido cargado dinamicamente).
     ───────────────────────────────────────────────────────── */

  function syncButton(btn) {
    var handle = btn.getAttribute('data-wishlist-handle');
    if (!handle) return;
    var active = WSWishlist.has(handle);
    btn.classList.toggle('is-active', active);
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    btn.setAttribute(
      'aria-label',
      active ? 'Quitar de lista de deseos' : 'Agregar a lista de deseos'
    );
  }

  function syncAllButtons() {
    var buttons = document.querySelectorAll('[data-wishlist-handle]');
    for (var i = 0; i < buttons.length; i++) syncButton(buttons[i]);
  }

  function syncHeaderCount() {
    var count = WSWishlist.getAll().length;
    var badges = document.querySelectorAll('[data-wishlist-count]');
    for (var i = 0; i < badges.length; i++) {
      var badge = badges[i];
      badge.textContent = count;
      if (count > 0) {
        badge.removeAttribute('hidden');
      } else {
        badge.setAttribute('hidden', '');
      }
    }
  }

  function handleClick(e) {
    var btn = e.target && e.target.closest
      ? e.target.closest('[data-wishlist-handle]')
      : null;
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    var item = {
      handle: btn.getAttribute('data-wishlist-handle'),
      id: btn.getAttribute('data-wishlist-id') || '',
      title: btn.getAttribute('data-wishlist-title') || '',
      vendor: btn.getAttribute('data-wishlist-vendor') || '',
      price: btn.getAttribute('data-wishlist-price') || '',
      compareAtPrice: btn.getAttribute('data-wishlist-compare-price') || '',
      image: btn.getAttribute('data-wishlist-image') || '',
      url: btn.getAttribute('data-wishlist-url') || ''
    };

    WSWishlist.toggle(item);
    syncButton(btn);
  }

  function init() {
    syncAllButtons();
    syncHeaderCount();
    document.addEventListener('click', handleClick);
    document.addEventListener('wishlist:change', function () {
      syncAllButtons();
      syncHeaderCount();
    });

    /* Sincronizar entre pestanas abiertas del mismo navegador */
    window.addEventListener('storage', function (e) {
      if (e.key === STORAGE_KEY) {
        syncAllButtons();
        syncHeaderCount();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
